import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-787045bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", { id: "flame-graph" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "highlight" }, [
  /*#__PURE__*/_createElementVNode("span", { id: "highlight-text" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mt-[5px] mr-0 mb-[5px] ml-0",
  id: "status"
}, null, -1))
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
]

import {onMounted} from "vue";
import {FLAME_GRAPH_CONFIG, FlameGraphWindow} from "@/views/flame-graph";


export default /*#__PURE__*/_defineComponent({
  __name: 'FlameGraph',
  setup(__props) {

onMounted(async () => {
  window.addEventListener("load", async () => {
    const wasm = await import("../../jfrv-wasm/pkg")
    const flameGraph = await FlameGraphWindow.flameGraph()
    const r = new wasm.FlameGraphRenderer(flameGraph, FLAME_GRAPH_CONFIG)
    window.onmousemove = (e) => {
      r.onmousemove(e)
    }
    window.onmouseout = (e) => {
      r.onmouseout(e)
    }
    window.onclick = (e) => {
      r.onclick(e)
    }
    r.render()
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "m-0 p-[10px] bg-white",
    style: _normalizeStyle(`font: ${_unref(FLAME_GRAPH_CONFIG).font}`)
  }, _hoisted_4, 4))
}
}

})